import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input-v3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "type", "placeholder", "required", "value", "maxlength", "name", "readonly"]
const _hoisted_4 = {
  key: 1,
  class: "input-v3_loader"
}

import { ref } from 'vue'
import AcPreloader from '@ui-kit/components/AcPreloader.vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'InputV3'
},
  __name: 'input',
  props: {
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  required: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {



const props = __props

const emit = __emit

const id = ref(`input-v3-${Math.ceil(Math.random() * 1000)}`)
const refInput = ref<HTMLInputElement | null>(null)

const handleInput = (event: Event) => {
  if (props.type === 'number' && props.maxlength && refInput.value) {
    if (refInput.value.value.length >= props.maxlength) {
      refInput.value.value = refInput.value.value.slice(0, props.maxlength)
    }
  }
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: id.value,
          class: "input-v3_label"
        }, _toDisplayString(__props.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: id.value,
      class: "input-v3_input",
      type: __props.type,
      placeholder: __props.placeholder,
      required: __props.required,
      value: __props.modelValue,
      maxlength: __props.maxlength,
      onInput: handleInput,
      ref_key: "refInput",
      ref: refInput,
      name: __props.name,
      readonly: __props.loading
    }, null, 40, _hoisted_3),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AcPreloader)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})